export const OktaClientId = '0oaop0jixngcdBAzt696'
export const ENV = 'productdemo' as string
export const OVERSIGHT_ENV_NAME = 'oversight-staging'
export const GCS_ENV_NAME = 'productdemo'
export const SUBDOMAIN_SUFFIX = 'gcs-staging'
